import React from 'react'

export default function StatWidget({ title, value, label, change, positive }) {
  const nVal = (typeof value === 'number') ? value : Number(value ?? 0);
  const nChange = (typeof change === 'number') ? change : Number(change ?? 0);
  const isPos = (typeof positive === 'boolean') ? positive : (nChange >= 0);
  return (
    <div className="widget stat-widget">
      <div className="widget-header">
        <h3 className="widget-title">{title}</h3>
      </div>
      <div className="stat-value">{Number.isFinite(nVal) ? nVal.toLocaleString() : (value ?? '0')}</div>
      <div className="stat-label">{label}</div>
      <div className={`stat-change ${isPos ? 'positive' : 'negative'}`}>
        <i className={`fas fa-arrow-${isPos ? 'up' : 'down'}`}></i>
        <span>{Number.isFinite(nChange) ? (nChange >= 0 ? `+${nChange}` : `${nChange}`) : (change ?? '')}</span>
      </div>
    </div>
  )
}
